import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AggrDeviceFieldAggrResponse } from '@/api/routes/stat/types';

import { fetchAggrDeviceAvgFieldAggr } from './actionCreators';

interface InitialState {
  aggrByAvgField: AggrDeviceFieldAggrResponse,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  aggrByAvgField: [],
  isLoading: false,
  error: '',
};

export const aggrDeviceByAvgFieldSlice = createSlice({
  name: 'aggrDeviceByAvgField',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAggrDeviceAvgFieldAggr.fulfilled.type]: (state, action: PayloadAction<AggrDeviceFieldAggrResponse>) => {
      state.isLoading = false;
      state.error = '';
      state.aggrByAvgField = action.payload;
    },
    [fetchAggrDeviceAvgFieldAggr.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchAggrDeviceAvgFieldAggr.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default aggrDeviceByAvgFieldSlice.reducer;
